import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";
import {TagType} from "../../../tags/angular/types/tag.type";

export class BringozMultiSelectFilterComponent implements IController {

  type: any;
  selectedIds: any;
  branchIds: any;
  carrierIds: any;
  agentTypes: any;
  skills?: string[];
  tags: any;
  tagType: TagType;
  billingAccountIds: any;
  options: any;
  optionIds: any;
  ngPlaceholder: any;
  excludeIds: any;
  rowLimit: any;
  isDisabled: any;
  canSelectAll: any;
  customSelectIcon: string;
  optionsPrefix: string;
  optionsWrapper?: { list?: any[], propertyRef: string };
  selectedCustomItems: { id: string, name: string }[];
  isExcludeMode: boolean;
  hideGroupsFilter: boolean;
  hideTagsFilter: boolean;
  isAllowExcludeMode: boolean;
  showTags?: boolean;
  onChange: Function;

  constructor(private $mdPanel, private $filter) {
  }

  $onInit() {
    if (!this.rowLimit) {
      this.rowLimit = 10;
    }
    this._updateSelectedCustomItems();
  }

  $onChanges(changes) {
    if (changes.selectedIds || changes.optionsWrapper) {
      this._updateSelectedCustomItems();
    }
  }

  onShowPanel($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-selection-button')
      .withAnimation(this.$mdPanel.animation.FADE);

    const typeRef = this.type;
    const selectedIdsRef = this.selectedIds || [];
    const billingAccountIdsRef = this.billingAccountIds;
    const agentTypesRef = this.agentTypes;
    const skillsRef = this.skills;
    const hideGroupsFilterRef = this.hideGroupsFilter;
    const hideTagsFilterRef = this.hideTagsFilter;
    const tagTypeRef = this.tagType;
    const branchIdsRef = this.branchIds;
    const carrierIdsRef = this.carrierIds;
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const ngPlaceholderRef = this.ngPlaceholder;
    const excludeIdsRef = this.excludeIds;
    const canSelectAllRef = this.canSelectAll;
    const tagsRef = this.tags;
    const showTagsRef = this.showTags;
    const optionsPrefixRef = this.optionsPrefix;
    const optionsWrapperRef = this.optionsWrapper;
    const isAllowExcludeModeRef = this.isAllowExcludeMode;
    const isExcludeModeRef = this.isExcludeMode;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-multi-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'hide-groups-filter="ctrl.hideGroupsFilterRef" ' +
        'hide-tags-filter="ctrl.hideTagsFilterRef" ' +
        'selected-ids="ctrl.selectedIdsRef" ' +
        'query-map="ctrl.queryMapRef" ' +
        'billing-account-ids="ctrl.billingAccountIdsRef"' +
        'options="ctrl.optionsRef" ' +
        'options-prefix="{{ctrl.optionsPrefixRef}}" ' +
        'options-wrapper="ctrl.optionsWrapperRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'exclude-ids="ctrl.excludeIdsRef" ' +
        'is-allow-exclude-mode="ctrl.isAllowExcludeModeRef"' +
        'is-exclude-mode="ctrl.isExcludeModeRef"' +
        'can-select-all="ctrl.canSelectAllRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'ng-placeholder="Search Branches">' +
        '</bringoz-multi-select-filter-panel>',
      controller: function () {
        this.typeRef = typeRef;
        this.selectedIdsRef = selectedIdsRef;
        this.queryMapRef = {
          agentTypes: agentTypesRef,
          skills: skillsRef,
          branchIds: branchIdsRef,
          carrierIds: carrierIdsRef,
          tagType: tagTypeRef,
          tags: tagsRef,
          showTags: showTagsRef
        };
        this.billingAccountIdsRef = billingAccountIdsRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.excludeIdsRef = excludeIdsRef;
        this.isAllowExcludeModeRef = isAllowExcludeModeRef;
        this.isExcludeModeRef = isExcludeModeRef;
        this.optionsPrefixRef = optionsPrefixRef;
        this.optionsWrapperRef = optionsWrapperRef;
        this.canSelectAllRef = canSelectAllRef;
        this.hideGroupsFilterRef = hideGroupsFilterRef;
        this.hideTagsFilterRef = hideTagsFilterRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedIds, isExcludeMode?) => {
        if (selectedIds === 'clickOutsideToClose' || selectedIds === 'escapeToClose') {
          selectedIds = selectedIdsRef;
        }
        this.onChange({selectedIds: selectedIds, isExcludeMode: isExcludeMode});
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({selectedIds: []});
  }

  onRemoveCustomItem(id: string) {
    this.onChange({selectedIds: _.filter(this.selectedIds, (selectedId) => selectedId !== id)});
  }

  private _updateSelectedCustomItems() {
    if (!this.optionsWrapper?.list || !this.selectedIds?.length) {
      this.selectedCustomItems = [];
      return;
    }

    this.selectedCustomItems = _.map(this.selectedIds, (id) => {
      const item = _.find(this.optionsWrapper.list, {id});
      let name = item ? _.get(item, this.optionsWrapper.propertyRef) : id;
      if (this.optionsPrefix) {
        name = this.$filter('translate')(this.optionsPrefix + '.' + name);
      }
      return {id, name};
    });
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozMultiSelectFilter', {
    bindings: {
      type: '@',
      selectedIds: '<?',
      branchIds: '<?',
      carrierIds: '<?',
      agentTypes: '<?',
      skills: '<?',
      tags: '<?',
      tagType: '<?',
      options: '<?',
      optionIds: '<?',
      billingAccountIds: '<?',
      ngPlaceholder: '<?',
      excludeIds: '<?',
      rowLimit: '<?',
      isDisabled: '<?',
      canSelectAll: '<?',
      customSelectIcon: '@?',
      optionsPrefix: '@?',
      optionsWrapper: '<?',
      isExcludeMode: '<?',
      isAllowExcludeMode: '<?',
      hideGroupsFilter: '<?',
      hideTagsFilter: '<?',
      showTags: '<?',
      onChange: '&'
    },
    template: require('./bringoz-multi-select-filter.html').default,
    controller: BringozMultiSelectFilterComponent
  });
